const getOpponentBase = <T extends OpponentBase>(opponent: T): OpponentBase => {
  const { id, name, acronym, image_url, slug, dark_mode_image_url } = opponent;
  return {
    id,
    name,
    acronym,
    image_url,
    slug,
    dark_mode_image_url
  };
};

const getOpponentsFromComposedData = (
  data: ComposedEntityData
): [OpponentBase | null, OpponentBase | null] => {
  let opponents: OpponentBase[] = [];

  // Try to get opponents from name block first
  if (data.name && !(data.name instanceof Error) && data.name?.opponents) {
    opponents = data.name.opponents;
  }

  // Fallback to head-to-head block
  if (
    opponents.length === 0 &&
    data['head-to-head'] &&
    !(data['head-to-head'] instanceof Error) &&
    data['head-to-head']?.opponents
  ) {
    opponents = data['head-to-head'].opponents;
  }

  // Try rosters block as another fallback
  if (
    opponents.length === 0 &&
    data.rosters &&
    !(data.rosters instanceof Error) &&
    data.rosters.opponents
  ) {
    opponents = data.rosters.opponents;
  }

  // Try form-guide block
  if (
    opponents.length === 0 &&
    data['form-guide'] &&
    !(data['form-guide'] instanceof Error) &&
    data['form-guide'].opponents
  ) {
    opponents = data['form-guide'].opponents;
  }

  // Try teams-stats block
  if (
    opponents.length === 0 &&
    data['teams-stats'] &&
    !(data['teams-stats'] instanceof Error) &&
    data['teams-stats'].opponents
  ) {
    opponents = data['teams-stats'].opponents;
  }

  // Try players-stats block
  if (
    opponents.length === 0 &&
    data['players-stats'] &&
    !(data['players-stats'] instanceof Error) &&
    data['players-stats']?.opponents
  ) {
    opponents = data['players-stats'].opponents;
  }

  return [null, null].map((defaultValue, index) => {
    const opponent = opponents.at(index);
    if (opponent) {
      return getOpponentBase(opponent);
    }
    return defaultValue;
  }) as [OpponentBase | null, OpponentBase | null];
};

export { getOpponentsFromComposedData };
